import { FileSystem } from "../../adapters/fileSystem";
import { ExportGenerator } from "../../adapters/exportGenerator";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  fileSystem: FileSystem,
  exportGenerator: ExportGenerator,
): Interactor {
  return ({ fileName, author, data, format }) =>
    present(
      exportGenerator.convert(data, format, author).then((fileData) =>
        fileSystem
          .write(`${fileName}.${format}`, fileData)
          .then((file) => ({ data, format, author, file }))
          .catch(() => Promise.reject({ fileName, data, author, format })),
      ),
    );
}

export type { Interactor };

export { createInteractor };
